import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import LoginPage from "./pages/LoginPage";
import DashboardLayout from "./components/DashboardLayout";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import BOQManagement from "./pages/BOQManagement";
import DPREntry from "./pages/DPREntry";
import DPRList from "./pages/DPRList";
import MaterialManagement from "./pages/MaterialManagement";
import WorkforceManagement from "./pages/WorkforceManagement";
import EquipmentManagement from "./pages/EquipmentManagement";
import ProgressTracking from "./pages/ProgressTracking";
import UserApproval from "./pages/UserApproval";
import AdvancedAnalytics from "./pages/AdvancedAnalytics";
import HRManagement from "./pages/HRManagement";
import ContractorManagement from "./pages/ContractorManagement";
import EquipmentMaintenance from "./pages/EquipmentMaintenance";
import BillingManagement from "./pages/BillingManagement";
import PayrollManagement from "./pages/PayrollManagement";
import ReportsPage from "./pages/ReportsPage";
import PurchaseOrders from "./pages/PurchaseOrders";
import ExecutiveDashboard from "./pages/ExecutiveDashboard";
import SitePhotos from "./pages/SitePhotos";
import SiteDiary from "./pages/SiteDiary";
import SafetyCompliance from "./pages/SafetyCompliance";
import QualityControl from "./pages/QualityControl";
import ProjectPlanning from "./pages/ProjectPlanning";
import AttendanceReport from "./pages/AttendanceReport";
import DataManagement from "./pages/DataManagement";
import MasterEquipment from "./pages/MasterEquipment";
import ArchiveManagement from "./pages/ArchiveManagement";
import { Toaster } from "@/components/ui/sonner";
import { InstallPrompt, OfflineIndicator } from "./components/PWAComponents";
import { getToken, getUser } from "./utils/authService";

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getToken();
    const userData = getUser();
    if (token && userData) {
      setUser(userData);
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  return (
    <div className="App">
      <OfflineIndicator />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={!user ? <LoginPage setUser={setUser} /> : <Navigate to="/" />} />
          <Route path="/" element={user ? <DashboardLayout user={user} setUser={setUser} /> : <Navigate to="/login" />}>
            <Route index element={<Projects />} />
            <Route path="dashboard/:projectId" element={<Dashboard />} />
            <Route path="projects" element={<Projects />} />
            <Route path="projects/:projectId" element={<ProjectDetail />} />
            <Route path="boq/:projectId" element={<BOQManagement />} />
            <Route path="dpr/:projectId" element={<DPREntry />} />
            <Route path="dpr-list/:projectId" element={<DPRList />} />
            <Route path="materials/:projectId" element={<MaterialManagement />} />
            <Route path="workforce/:projectId" element={<WorkforceManagement />} />
            <Route path="equipment/:projectId" element={<EquipmentManagement />} />
            <Route path="progress/:projectId" element={<ProgressTracking />} />
            <Route path="analytics/:projectId" element={<AdvancedAnalytics />} />
            <Route path="user-approvals" element={<UserApproval />} />
            <Route path="hr" element={<HRManagement />} />
            <Route path="contractors" element={<ContractorManagement />} />
            <Route path="maintenance" element={<EquipmentMaintenance />} />
            <Route path="billing" element={<BillingManagement />} />
            <Route path="payroll" element={<PayrollManagement />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="purchase-orders" element={<PurchaseOrders />} />
            <Route path="dashboard" element={<ExecutiveDashboard />} />
            <Route path="site-photos" element={<SitePhotos />} />
            <Route path="site-diary" element={<SiteDiary />} />
            <Route path="safety" element={<SafetyCompliance />} />
            <Route path="quality" element={<QualityControl />} />
            <Route path="planning/:projectId" element={<ProjectPlanning />} />
            <Route path="attendance-report" element={<AttendanceReport />} />
            <Route path="data-management" element={<DataManagement />} />
            <Route path="master-equipment" element={<MasterEquipment />} />
            <Route path="archives" element={<ArchiveManagement />} />
            <Route path="archives/:projectId" element={<ArchiveManagement />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
      <InstallPrompt />
    </div>
  );
}

export default App;